export default {
  importPlansFor: 'Import plans for model:',
  import: 'Import',
  json: 'JSON',
  createdPlans: 'Created plans:',
  errors: 'Errors:',
  invalidJson: 'Invalid JSON',
  noPlansToImport: 'No plans available to import',
  missingPlanName: 'Missing plan name',
  channelMismatch: 'Its media channels don\'t match the model exactly. Missing in plan: {missing}. Not in the model: {extra}. Nothing was imported.',
  touchpointMismatch: 'It references media that don\'t exist in the model: {items}. Nothing was imported.'
}
